// src/lib/start-download.ts
//
// One seam for "the browser downloads this URL". The export routes answer with an attachment, so handing the
// URL to the browser is the whole job; keeping it behind a function lets a DOM test see WHICH url (and so which
// filters) a Download button asked for, which `window.location` itself will not let a test observe.
export function startDownload(url: string): void {
  window.location.href = url
}
